module.exports = __webpack_public_path__ + "img/LogoLoading_circle02.f1acb18f.png";